<mat-toolbar class="header mat-elevation-z1">
  <div class="header__left-menu">
    <img class="header__logo" src="assets/icons/logo.svg" alt="logo" />
    <ng-container *ngTemplateOutlet="leftNavigationButtonsTemplate"></ng-container>
  </div>
  <div class="header__space-occupier"></div>
  <div class="header__right-menu">
    <button
      mat-icon-button
      class="header__columns-icon-button"
      *ngIf="showColumnsButton"
      (click)="onOpenEditColumnsPanelBtn()">
      <mat-icon>playlist_add</mat-icon>
    </button>
    <button
      mat-button
      class="custom-button header__export-button header__export-button_desktop"
      *ngIf="!hideExportButton && isNotOfficer"
      (click)="onExportClick()">
      Export
      <mat-icon iconPositionEnd>system_update_alt</mat-icon>
    </button>
    <button
      *ngIf="isNotOfficer"
      mat-icon-button
      class="header__export-button header__export-button_mobile"
      (click)="onExportClick()">
      <mat-icon>system_update_alt</mat-icon>
    </button>
    <button
      *ngIf="isNotOfficer"
      mat-stroked-button
      class="custom-button header__filter-button"
      (click)="openFilterDialog.emit()"
      [disabled]="isFiltersDisabled$ | async">
      Filters
    </button>
    <button mat-icon-button *ngIf="sideNavOpenable" (click)="toggleSideNav.emit()">
      <mat-icon>{{ sideNavOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>
</mat-toolbar>
